import { defineStore } from 'pinia'
import { useEntity } from '@/composables/entity'

const useBatchStore = defineStore('batches', () => {
  const {
    entities: batches,
    selected,
    meta,
    links,
    loading,
    refetch,
    notFound
  } = useEntity<Batch>()

  const setRefetch = (value: boolean): void => {
    refetch.value = value
  }

  return {
    batches,
    selected,
    meta,
    links,
    loading,
    refetch,
    notFound,
    setRefetch
  }
})

export default useBatchStore
